import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { BoschUiIconNames } from '../../../atoms/bosch-ui-icon/bosch-ui-icon.constants';

@Component({
  selector: 'bosch-ui-step-indicator-step',
  templateUrl: './bosch-ui-step-indicator-step.component.html',
  styleUrls: ['./bosch-ui-step-indicator-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiStepIndicatorStepComponent {
  @Input() indicator: string | number | null = null;
  @Input() iconIndicator: BoschUiIconNames | null = null;
  @Input() label: string | null = null;
  @Input() active = false;
  @Input() complete = false;
  @Input() testId: string | null = null;
  @Input() set width(width: string | number) {
    if (typeof width === 'number') {
      this.customWidth = width + 'px';

      return;
    }

    this.customWidth = width;
  }
  @ViewChild('stepTemplate') template!: TemplateRef<unknown>;

  protected customWidth: string | null = null;
}
